import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["reasons", "badge", "status", "save"];
  static values = { key: String };

  connect() {
    // Keep unfinished tester notes through check-in polling and panel replacement.
    try {
      const draft = JSON.parse(sessionStorage.getItem(this.storageKey) || "null");
      if (draft) {
        this.element.querySelectorAll('input[name="review[status]"]').forEach((input) => { input.checked = input.value === draft.status; });
        this.element.querySelectorAll('input[name="review[reasons][]"]').forEach((input) => { input.checked = draft.reasons.includes(input.value); });
        this.element.querySelector("textarea").value = draft.notes;
        this.statusTarget.textContent = "Unsaved changes";
      }
    } catch { /* Feedback works without browser storage. */ }
    this.toggleReasons();
  }

  get storageKey() { return `closegap-demo-review:${this.keyValue}`; }

  values() {
    return {
      status: this.element.querySelector('input[name="review[status]"]:checked')?.value || "",
      reasons: Array.from(this.element.querySelectorAll('input[name="review[reasons][]"]:checked')).map((input) => input.value),
      notes: this.element.querySelector("textarea").value,
    };
  }

  toggleReasons() {
    const flagged = this.values().status === "flagged";
    this.reasonsTarget.hidden = !flagged;
    this.reasonsTarget.disabled = !flagged;
  }

  change() {
    this.toggleReasons();
    this.statusTarget.textContent = "Unsaved changes";
    try { sessionStorage.setItem(this.storageKey, JSON.stringify(this.values())); } catch {}
  }

  async save(event) {
    event.preventDefault();
    if (this.saving) return;
    this.saving = true;
    this.saveTarget.disabled = true;
    this.statusTarget.textContent = "Saving…";
    const form = event.currentTarget;
    const data = new FormData(form);
    const submitted = this.values();
    try {
      const response = await fetch(form.action, {
        method: "POST", body: data, credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || "Could not save feedback. Try again.");
      this.badgeTarget.textContent = result.review.status === "flagged" ? "Flagged for review" : "Good check-in";
      this.badgeTarget.dataset.status = result.review.status;
      const unchanged = JSON.stringify(this.values()) === JSON.stringify(submitted);
      this.statusTarget.textContent = unchanged ? "Feedback saved" : "Saved. You have unsaved changes.";
      if (unchanged) {
        try { sessionStorage.removeItem(this.storageKey); } catch {}
      }
    } catch (error) {
      this.statusTarget.textContent = error.message || "Could not save feedback. Try again.";
    } finally {
      this.saving = false;
      this.saveTarget.disabled = false;
    }
  }
}
